import { useOrgConfigStateValue } from 'hooks/business/useOrgConfig';

function useLLM() {
  const { qaEnable, whiteListConfig: { LLM: _LLM, QA_AI_3 } = {} } = useOrgConfigStateValue();
  return qaEnable ? QA_AI_3 : _LLM;
}

export default useLLM;
